import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const SECTIONS = [
  {
    h: "1. Access to Our Site",
    body: [
      "1.1 Access to our Site is provided on a temporary basis, and we reserve the right to:",
      "• Withdraw access to the Site",
      "• Change or discontinue any service or feature on the Site without prior notice",
      "1.2 We will not be held liable for any unavailability of the Site, at any time or for any duration.",
      "1.3 You are responsible for:",
      "• Ensuring access to the Site",
      "• Ensuring any individuals using your internet connection are aware of these Terms and comply with them",
      "1.4 You agree not to:",
      "• Damage, interfere with, or disrupt access to the Site",
      "• Perform any action that interrupts or impairs the Site's functionality",
    ],
  },
  {
    h: "2. Use of Information",
    body: [
      "2.1 The content on the Site is for general informational purposes only. While we strive to ensure accuracy, we cannot guarantee that information is complete, up-to-date, or error-free.",
      "2.2 You must not rely solely on the content of this Site for making decisions. You acknowledge that you are responsible for verifying any information before acting on it.",
      "2.3 We reserve the right to modify or remove content on the Site at any time without notice.",
    ],
  },
  {
    h: "3. Intellectual Property Rights",
    body: [
      "3.1 All intellectual property rights on the Site, including but not limited to copyright, trademarks, design rights, database rights, and trade secrets (“Intellectual Property”), are owned or licensed by Brett Weller - Keller Williams DTC.",
      "3.2 You may:",
      "• View, print, and download material from the Site for personal, non-commercial use only",
      "3.3 You may not:",
      "• Modify, reproduce, or republish content from the Site",
      "• Use any content for commercial purposes without our express written permission",
      "• Attempt to reverse engineer, disassemble, or decompile any part of the Site",
      "All rights not explicitly granted to you in these Terms are reserved.",
    ],
  },
  {
    h: "4. User Conduct",
    body: [
      "By accessing or using the Site, you agree that you will:",
      "• Use the Site only for lawful purposes",
      "• Refrain from using the Site to transmit malicious software, spam, or any illegal or harmful content",
      "We reserve the right to restrict or terminate your access to the Site if you breach these Terms.",
    ],
  },
  {
    h: "5. Monitoring",
    body: [
      "We reserve the right to monitor and track user activity on the Site to ensure compliance with these Terms and improve user experience.",
    ],
  },
  {
    h: "6. Limitation of Liability",
    body: [
      "6.1 To the maximum extent permitted by law, we disclaim all liability for:",
      "• Any direct, indirect, or consequential loss arising from your use of or reliance on content available on the Site",
      "• Interruptions or errors in Site functionality",
      "6.2 No Warranties: The Site is provided on an \"as is\" and \"as available\" basis. We make no warranties, either express or implied, regarding the accuracy, completeness, or availability of the Site.",
    ],
  },
  {
    h: "7. Links to Third-Party Sites",
    body: [
      "The Site may contain links to third-party websites. We do not control or endorse these sites and are not responsible for their content, privacy practices, or availability. You access such third-party sites at your own risk.",
    ],
  },
  {
    h: "8. Privacy Policy",
    body: [
      "Your use of the Site is also governed by our Privacy Policy. Please review it to understand how we collect, use, and safeguard your information.",
    ],
  },
  {
    h: "9. Changes to These Terms",
    body: [
      "We may revise these Terms at any time by updating this page. Continued use of the Site after changes indicates your acceptance of the revised Terms.",
    ],
  },
  {
    h: "10. Governing Law",
    body: [
      "These Terms are governed by and construed in accordance with the laws of CO. Any disputes arising out of these Terms shall be subject to the exclusive jurisdiction of the courts of CO.",
    ],
  },
  {
    h: "11. Contact Us",
    body: [
      "If you have any questions or concerns about these Terms, please contact us at: brettweller34@gmail.com",
    ],
  },
];

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-28">
        <section className="border-b border-neutral-200 bg-[#FAFAFA]">
          <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20">
            <p className="overline text-kw-red mb-4">Legal</p>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-kw-ink leading-[1.02]">
              Terms &amp; Conditions
            </h1>
          </div>
        </section>

        <article data-testid="terms-content" className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20">
          <p className="text-neutral-700 leading-relaxed">
            Welcome to Brett Weller - Keller Williams DTC's website (“Site”), located at{" "}
            <a href="https://www.wellerpropertyteam.com" className="text-kw-red hover:text-kw-redhover">
              www.wellerpropertyteam.com
            </a>
            . These Terms and Conditions (“Terms”) govern your use of the Site. By accessing or using
            the Site, you agree to comply with and be bound by these Terms. If you do not agree to
            these Terms, you must stop using the Site immediately.
          </p>
          <p className="mt-4 text-neutral-700 leading-relaxed">
            We may update these Terms periodically by amending this page. It is your responsibility to
            review this page regularly as changes are binding upon you.
          </p>

          <div className="mt-12 space-y-10">
            {SECTIONS.map((s) => (
              <div key={s.h}>
                <h2 className="font-serif text-2xl sm:text-3xl tracking-tight text-kw-ink mb-4">{s.h}</h2>
                <div className="space-y-3">
                  {s.body.map((line, i) => (
                    <p
                      key={i}
                      className={`leading-relaxed ${line.startsWith("•") ? "pl-5 text-neutral-600" : "text-neutral-700"}`}
                    >
                      {line}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
